import React, { useEffect, useState, useRef } from "react";
import "./ModalGestionPacientes.css";
import { updatePaciente, getTodosPacientes } from "../../../services/pacientes";

const ModalGestionPacientes = ({ isOpen, onClose, onUpdated }) => {
  const [pacientes, setPacientes] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");
  


  // 🧠 Guardamos el estado original para saber qué cambió
  const originalActivosRef = useRef({});

  useEffect(() => {
    if (!isOpen) return;

    const fetchAll = async () => {
      setLoading(true);
      try {
        const data = await getTodosPacientes();
        setPacientes(data);

        // Guardar snapshot original
        const snapshot = {};
        data.forEach(p => {
          snapshot[p.id] = p.activo;
        });
        originalActivosRef.current = snapshot;

      } catch (e) {
        console.error("Error cargando pacientes:", e);
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, [isOpen]);

  const toggleActivo = (id, value) => {
    setPacientes(prev =>
      prev.map(p =>
        p.id === id ? { ...p, activo: value } : p
      )
    );
  };
  
  const toggleTodosFiltrados = () => {
    if (filtrados.length === 0) return;

    const todosActivos = filtrados.every(p => p.activo === true);
    const nuevoValor = !todosActivos;

    setPacientes(prev =>
      prev.map(p =>
        filtrados.find(f => f.id === p.id)
          ? { ...p, activo: nuevoValor }
          : p
      )
    );
  };

  const aplicarCambios = async () => {
    setLoading(true);
    try {
      for (const p of pacientes) {
        const original = originalActivosRef.current[p.id];
        if (original !== p.activo) {
          await updatePaciente(p.id, { activo: p.activo });
        }
      }

      onUpdated?.();
      onClose();
    } catch (e) {
      console.error("Error guardando cambios:", e);
      alert("Error guardando cambios");
    } finally {
      setLoading(false);
    }
  };

const toDateKeyCDMX = (iso) => {
  if (!iso) return "";
  const date = new Date(iso);
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Mexico_City",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date); // => "YYYY-MM-DD"
};

const filtrados = pacientes.filter((p) => {
  const q = (search || "").toLowerCase();
  const nombre = `${p.nombre} ${p.apellido_paterno || ""} ${p.apellido_materno || ""}`.toLowerCase();

  if (!nombre.includes(q)) return false;

  if (fechaDesde || fechaHasta) {
    const fechaAltaKey = toDateKeyCDMX(p.fecha_registro);

    if (fechaDesde && fechaAltaKey < fechaDesde) return false;
    if (fechaHasta && fechaAltaKey > fechaHasta) return false; // ✅ INCLUYENTE
  }

  return true;
});


  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal-gestion-pacientes">
        <h3>Gestión de Pacientes</h3>
        <p>Para archivar pacientes, apaga el switch. Los pacientes quedaran guardados pero no se mostrarán en tu tablero. (puedes deshacerlo cambiando el switch nuevamente y guardando)</p>

        <input
          type="text"
          placeholder="Buscar por nombre"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
         <p>filtro fecha:</p>
      <div className="filtro-fecha-rango">
       

        <div className="filtro-fecha">
            <div className="filtro-campo">
              <label>Desde</label>
              <input
                type="date"
                value={fechaDesde}
                onChange={(e) => setFechaDesde(e.target.value)}
              />
            </div>

            <div className="filtro-campo">
              <label>Hasta</label>
              <input
                type="date"
                value={fechaHasta}
                onChange={(e) => setFechaHasta(e.target.value)}
              />
            </div>
          </div>
      </div>

      {filtrados.length > 0 && (
        <button
          type="button"
          className="btn-secondary"
          style={{ marginBottom: "10px" }}
          onClick={toggleTodosFiltrados}
        >
          Seleccionar / Deseleccionar todos los filtrados
        </button>
      )}

     
        <div className="pacientes-scroll">
          {loading ? (
            <p>Cargando...</p>
          ) : (
            filtrados.map(p => (
              <div key={p.id} className="paciente-row">
                <div className="paciente-info">
                  <strong>
                    {p.nombre} {p.apellido_paterno} {p.apellido_materno || ""}
                  </strong>
                  <small>
                    Alta: {new Date(p.fecha_registro).toLocaleDateString("es-MX")}
                  </small>
                </div>

                {/* ✅ ÚNICO CONTROL */}
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={p.activo}
                    onChange={(e) => toggleActivo(p.id, e.target.checked)}
                  />
                  <span className="slider" />
                </label>
              </div>
            ))
          )}
        </div>

        <div className="modal-actions">
          <button onClick={onClose} className="btn-secondary">
            Atrás
          </button>
          <button onClick={aplicarCambios} className="btn-primary">
            Guardar cambios
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalGestionPacientes;
